import { Reveal, Eyebrow } from "./Reveal";

const DIRECTORS = [
  {
    id: "alkaben",
    name: "Alkaben Vinodbhai Patel",
    role: "CEO · Chief Executive Officer",
    line: "Leads Adveshta’s organic dairy vision — advocating organic practices for healthier, sustainable food choices.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_78af94ff-cb5b-4e57-8cab-95aee2a44f00/artifacts/9rh9i481_20210424_165209.webp",
  },
  {
    id: "nachiket",
    name: "Nachiket Vinodbhai Patel",
    role: "COO · Chief Operating Officer",
    line: "Leads village partnerships and operations — fair-trade sourcing, regenerative farming and water management.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_78af94ff-cb5b-4e57-8cab-95aee2a44f00/artifacts/gw79b7hw_20210424_170941.webp",
  },
];

export default function Directors() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="bg-ink text-cream py-24 lg:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <Reveal>
          <Eyebrow>07 — Leadership</Eyebrow>
          <h2 className="mt-6 font-serif font-semibold text-4xl md:text-5xl leading-[1.05] tracking-tight max-w-2xl">
            The people behind the pour.
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {DIRECTORS.map((d, i) => (
            <Reveal key={d.id} delay={i * 0.12} className="h-full">
              <article
                data-testid={`director-card-${d.id}`}
                className="group h-full rounded-3xl overflow-hidden border border-cream/12 bg-pine/20 hover:border-gold/50 transition-colors duration-500"
              >
                <div className="h-[340px] md:h-[440px] overflow-hidden">
                  <img
                    src={d.image}
                    alt={`${d.name}, ${d.role} of Adveshta Projects`}
                    className="h-full w-full object-cover object-[center_25%] transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                </div>
                <div className="p-8 md:p-10">
                  <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
                    {d.role}
                  </p>
                  <h3 className="mt-3 font-serif text-2xl md:text-3xl">{d.name}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-cream/60">{d.line}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
